import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  closeBtn: {
    id: 'kPSIeE',
    defaultMessage: 'Close',
    description: 'Button to close import',
  },
  importIsProcessing: {
    id: 'C27XDe',
    defaultMessage: 'Your import is processing',
    description: 'Message that import is processing',
  },
  importInProgress: {
    id: 'Y3AmDV',
    defaultMessage: 'Import in progress...',
    description: 'Message that import is in progress',
  },
  loadingSummaryInProgress: {
    id: 'Wy+Iga',
    defaultMessage: 'Loading summary in progress...',
    description: 'Message that loadign summary is in progress',
  },
  importSummaryErrors: {
    id: 'YmD6qc',
    defaultMessage: 'Errors/Warnings',
    description: 'Message that import summary errors or warnings',
  },
  closeInfoMessage: {
    id: '4fy+YS',
    defaultMessage: "You can close this window while the import is in progress. You'll be notified when the import completes.",
    description: 'Message that user can close import modal',
  },
  failedImportedRows: {
    id: 'F4wQr2',
    defaultMessage:
      '{failedCount, plural, one {# row} other {# rows}} had invalid or missing data. Please correct the data in the file and try again.',
    description: 'Failed imported rows',
  },
  importDetailsSuccess: {
    id: 'DM8FS8',
    defaultMessage: 'We successfully processed {processed, plural, one {# row} other {# rows}}.',
    description: 'Failed imported rows',
  },
  importDetailsWarnings: {
    id: 'uAlTNF',
    defaultMessage:
      'We successfully processed {processed, plural, one {# row} other {# rows}} with {warningsCount, plural, one {# warning} other {# warnings}}.',
    description: 'Failed imported rows',
  },
  rowErrorDetails: {
    id: 'flAMFv',
    defaultMessage: 'Row {rowNum}: {message}',
    description: 'Row error details',
  },
  errorLoadingSummary: {
    id: 'eVJal5',
    defaultMessage: 'An error occurred while loading summary',
    description: 'Error on the last step occurred while loading summary',
  },
  retryBtn: {
    id: 'u3mzMH',
    defaultMessage: 'Retry',
    description: 'Button to retry fetching import summary',
  },
  unexpectedFail: {
    id: 'nuf5xU',
    defaultMessage: 'Your import failed unexpectedly. Please try again or contact support.',
    description: 'Unexpected import fail message.',
  },
  checkingProgress: {
    id: '5eA1mA',
    defaultMessage: 'Checking progress...',
    description: 'Checking progress message',
  },
  progressDetails: {
    id: 'OBbuiB',
    defaultMessage: '{processed} out of {total}',
    description: 'Information about progress',
  },
  warning: {
    id: 'irUpW2',
    defaultMessage: 'WARNING',
    description: 'Warning message prefix',
  },
  error: {
    id: 'zvHxML',
    defaultMessage: 'ERROR',
    description: 'Error message prefix',
  },
  summaryMessage: {
    id: 'Z6RgwT',
    defaultMessage: 'Row {rowNumber}: {severity}: {attributeCode} {description}',
    description: 'Full summary message',
  },
});
